export default __webpack_public_path__ + "static/media/halfRedGray.63a94eed.svg";